// 帳號類型：對應舊系統的 enum, 不要任意更改.
export enum LegacyMemberType {
  EMAIL = 0,
  PHONE = 1,
  FACEBOOK = 2,
  APPLEID = 3,
}

// 平台類型：對應舊系統的 enum, 不要任意更改.
export enum LegacyPlatformType {
  Unknow = 0,
  iOS = 1,
  Android = 2,
  WebMobile = 3,
  PC = 4,
}

// 結清狀態
export enum LegacySettleStatus {
  // 已申請
  APPLY = 1,

  // 已入帳
  ENTERED = 2,

  // 取消
  CANCEL = 3,
}

// 訂單類型
export enum LegacyOrderType {
  SEVEN = 0,
  CREDIT = 1,
  CVS = 2,
  COD = 3,
  OVERSEAS = 4,
  LINE_PAY = 5,
}

// 訂單歷史狀態
export enum LegacyOrderHistoryStatus {
  NONE = 0,
  ORDER_CREATED = 10,
  PROCESSING = 20,
  OUT_WAREHOUSE = 40,
  PACKAGE_ON_ROAD = 50,
  ARRIVAL = 60,
}

// 歷程狀態
export enum LegacyOrderTrackingStatus {
  // 新訂單
  NEW_ORDER = 1,

  // 特殊訂單
  SPECIAL_ORDER = 5,

  // 訂單異常
  ORDER_EXCEPTION = 10,

  // 訂單處理中
  ORDER_PROCESSING = 15,

  // 出貨中
  SHIPPING = 20,

  // 取消作業中
  CANCELLATION_IN_PROGRESS = 25,

  // 列印完成
  PRINTING_COMPLETED = 30,

  // 揀貨中
  PICKING = 35,

  // 裝車出庫
  LOADING_AND_DEPARTURE = 40,

  // 正在派送中
  OUT_FOR_DELIVERY = 45,

  // 門市進店
  STORE_ARRIVAL = 47,

  // 包裹未取退回
  PACKAGE_NOT_PICKED_RETURNED = 49,

  // 已簽收
  DELIVERED = 50,
}

// 信用卡狀態
export enum LegacyOrderCreditStatus {
  // 未完成授權
  NoAuth = 101,
}

// 訂單狀態
export enum LegacyOrderDetailStatus {
  // 待付款
  WAIT_BUYER_PAY = 1,
  // 待出貨
  WAIT_SELLER_SEND = 2,
  // 已出貨
  WAIT_BUYER_CONFIRM = 3,
  // 已取消訂單
  CANCELED = 90,
  // 未領取消訂單
  NO_PICKUP = 91,
  // 未完成付款取消訂單
  UNCOMPLETED_PAY = 92,
  // 訂單已取消申請退款
  CANCELED_APPLY_REFUND = 93,
  // 訂單已取消退款處理中
  CANCELED_REFUND_REQUESTED = 94,
  // 退款完成
  REFUND_SUCCESS = 99,
  // 訂單已完成 (已送達、已完成取件)
  COMPLETE = 100,
}

export enum LegacyMessageGroupType {
  // 客服訊息
  CUSTOMER_SERVICE = 1,

  // 活動消息
  EVENT = 2,

  // 通知消息
  NOTIFICATION = 3,

  // 物流消息
  LOGISTICS = 4,

  // 商品訊息通知
  PRODUCT = 5,
}

export enum LegacyMessageContentType {
  ALL = 1,
  Image = 2,
  Text = 3,
}

export enum LegacyAppPushType {
  // 訂單成立通知
  ORDER_CREATED_NOTIFICATION = 1,

  // 取消訂單通知
  ORDER_CANCELED_NOTIFICATION = 2,

  // 取消付款訂單通知
  PAYMENT_CANCELED_NOTIFICATION = 3,

  // 訂單出貨通知
  ORDER_SHIPPED_NOTIFICATION = 4,

  // 門市取件通知First
  STORE_PICKUP_NOTIFICATION_FIRST = 5,

  // 門市取件通知Second
  STORE_PICKUP_NOTIFICATION_SECOND = 6,

  // 電子發票成立通知
  E_INVOICE_CREATED_NOTIFICATION = 7,

  // 客服留言回覆通知
  CUSTOMER_SERVICE_REPLY_NOTIFICATION = 8,

  // 退貨申請通知
  RETURN_REQUEST_NOTIFICATION = 9,

  // 退貨商品收到通知
  RETURN_ITEM_RECEIVED_NOTIFICATION = 10,

  // 退貨完成驗收通知
  RETURN_COMPLETED_INSPECTION_NOTIFICATION = 11,

  // 完成退款通知
  REFUND_COMPLETED_NOTIFICATION = 12,

  // 完成退款通知Credit
  REFUND_COMPLETED_CREDIT_NOTIFICATION = 13,

  // 退貨餘額發票開立通知
  RETURN_BALANCE_INVOICE_ISSUED_NOTIFICATION = 14,

  // 結清轉帳成功通知
  SETTLEMENT_TRANSFER_SUCCESS_NOTIFICATION = 15,

  // 密碼重置通知
  PASSWORD_RESET_NOTIFICATION = 16,

  // 會員忘記密碼
  MEMBER_FORGOT_PASSWORD = 17,

  // 電子發票中獎通知
  E_INVOICE_WINNING_NOTIFICATION = 18,

  // 到貨提醒
  ARRIVAL_REMINDER = 19,

  // 客服主動留言通知
  CUSTOMER_SERVICE_INITIATED_MESSAGE_NOTIFICATION = 20,

  // 退貨取消通知
  RETURN_CANCELED_NOTIFICATION = 21,

  // 結清轉帳失敗通知
  SETTLEMENT_TRANSFER_FAILED_NOTIFICATION = 22,

  // 逾期取貨取消訂單通知
  OVERDUE_PICKUP_ORDER_CANCELED_NOTIFICATION = 23,

  // 已申請未退回通知
  NOT_RETURNED_NOTIFICATION = 24,

  // 未付款取消訂單通知
  UNPAID_ORDER_CANCELED_NOTIFICATION = 25,

  // 雲端發票中獎通知
  CLOUD_INVOICE_WINNING_NOTIFICATION = 26,
}

export enum LegacyMessageLinkType {
  // 活動消息
  NONE = 0,

  // 查看特價商品
  CHECK_SALE = 1,

  // 查看訂單詳情
  CHECK_ORDER = 2,

  // 查看物流詳情
  CHECK_LOGISTIC = 3,

  // 查看退貨詳情
  CHECK_RETURN = 4,

  // 查看商品詳情
  CHECK_PRODUCT = 5,

  // 自定義Url
  CUSTOM_URL = 6,
}

// 退貨方式
export enum LegacyReturnType {
  // 退貨便寄回
  CONVENIENCE_STORE = 0,

  // 宅配取件
  LOGISTICS = 1,

  // 自行寄回
  SELF = 2,
}

// 忘記密碼步驟
export enum LegacyForgotPasswordStep {
  // 輸入帳號
  INPUT_ACCOUNT = 0,

  // 太久沒登入, 需要驗證會員姓名
  VERIFY_NAME = 1,

  // 輸入驗證碼, 或重新發送驗證碼
  VERIFY_CODE = 2,

  // 重設密碼
  RESET_PASSWORD = 3,

  // EMAIL 重設密碼
  EMAIL_RESET = 4,
}
